/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Sc_ClickInputs */

const en_pc_tut_sc_click = /** @type {(inputs: Pc_Tut_Sc_ClickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`click`)
};

const zh_pc_tut_sc_click = /** @type {(inputs: Pc_Tut_Sc_ClickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`点击`)
};

/**
* | output |
* | --- |
* | "click" |
*
* @param {Pc_Tut_Sc_ClickInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_sc_click = /** @type {((inputs?: Pc_Tut_Sc_ClickInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Sc_ClickInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_sc_click(inputs)
	return zh_pc_tut_sc_click(inputs)
});
export { pc_tut_sc_click as "pc.tut.sc.click" }